import React, { useEffect, useState } from 'react'
import { postCancelarDespachosQxFarmacia, postMotivoDespachosQxFarmacia } from '../../../services/FarmaciaRuta'
import TablaCancelarSuministro from './TablaCancelarSuministro'

const ModalCancelarSuministro = ({setmodalOnCancelarSuministros,item,actualizarTablaDespacho}) => {
  const usuarioInfo = JSON.parse(localStorage.getItem('usuarioInfo'));
    const [errorMotivo, seterrorMotivo]=useState('')
    const [dataMotivo,setdataMotivo]=useState([])
    const [seleccionarMotivo,setseleccionarMotivo]=useState({
      PQConTip:'',
      PQConCod:'',
      ConDsc:''
    })

    const handleOnclickCancelarDespacho=()=>{
      const cancelarDespacho={
        ProEmpCod:usuarioInfo.Empresa,
        ProMCDpto:usuarioInfo.Sede,
        ProCirCod:item.ProCirCod,
        PaqCod:item.PaqCod,
        PQUsuDes: usuarioInfo.UsuarioEncriptado,
        PQEdoDes:'C',
        PQConTip: seleccionarMotivo.PQConTip,
        PQConCod: seleccionarMotivo.PQConCod
      }
      if(errorMotivo === ''){
        postCancelarDespachosQxFarmacia(cancelarDespacho).then((res)=>{
          console.log(res.data,'cancelado')
          actualizarTablaDespacho(cancelarDespacho)
          setmodalOnCancelarSuministros(false)
        })
      }
      
    }

    const passDataSeleccionarMotivo=(data)=>{
      setseleccionarMotivo(data)
      seterrorMotivo('')
    }

    const handleCancelarClick=()=>{
        setmodalOnCancelarSuministros(false)
    }
    useEffect(()=>{
        seterrorMotivo('Seleccionar el Motivo ')
        const motivo={
            EMPCOD:usuarioInfo.Empresa
        }
        postMotivoDespachosQxFarmacia(motivo).then((res)=>{
            console.log(res.data)
            setdataMotivo(res.data)
        })
    },[])
  return (
    <div
      className="z-40 fixed top-0 left-0 w-full h-full outline-none overflow-x-hidden overflow-y-auto bg-slate-900 bg-opacity-25"
      id="exampleModalScrollable"
      tabIndex="-1"
      aria-labelledby="exampleModalScrollableLabel"
      aria-hidden="true"
    >
      <div className="sm:h-[calc(100%-3rem)] max-w-2xl my-6 mx-auto relative w-auto pointer-events-none ">
        <div className="max-h-full overflow-hidden border-none shadow-lg relative flex flex-col w-full pointer-events-auto bg-white bg-clip-padding rounded-md outline-none text-current">
          <div className="flex flex-shrink-0 items-center justify-between p-2 border-b border-gray-200 rounded-t-md bg-[#f87171]">
            <h5
              className="text-xl font-medium leading-normal text-white"
              id="exampleModalScrollableLabel"
            >
              Cancelar Despacho
            </h5>
            <button
              type="button"
              onClick={handleCancelarClick}
              className="btn-close box-content w-4 h-4 p-1 text-white border-none rounded-none opacity-50 focus:shadow-none focus:outline-none focus:opacity-100 hover:text-black hover:opacity-75 hover:no-underline"
              data-bs-dismiss="modal"
              aria-label="Close"
            >
              X
            </button>
          </div>
          <div className="flex-auto overflow-y-auto relative p-4">
          <div className="flex flex-row py-1  text-left">
            <div className="w-1/2  px-1 ">
              <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                Motivo
              </label>
              <input
                //onClick={handleOnclickListaPersonalEnfermeria}
                defaultValue={seleccionarMotivo.PQConCod}
                disabled={true}
                name="cedulaPaciente"
                type="text"
                className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                id="exampleFormControlInput1"
                placeholder=""
              />
              <label className="form-label inline-block mb-2 text-red-900 text-sm font-medium">
                {errorMotivo}
              </label>
            </div>
            <div className="w-1/2  px-1 pt-2">
              <label className="form-label inline-block mb-2 text-gray-900 font-medium "></label>
              <input
                //disabled={true}
                //defaultValue={dataUser.MPTDoc}
                defaultValue={seleccionarMotivo.ConDsc}
                disabled={true}
                type="text"
                className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                id="exampleFormControlInput1"
                placeholder=""
              />
            </div>
            {/* <div className="mt-8">
              <button
                //onClick={handleOnclickModalOnProgramacionDeCirugia}
                type="submit"
                className="inline-block px-4 py-1.5 bg-blue-600 text-white font-medium text-xs leading-tight  rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out"
              >
                Buscar
              </button>
            </div> */}
          </div>
          <div className="flex flex-col">
          <div className="overflow-x-auto  ">
            <div className="py-4 inline-block min-w-full">
              <div className="overflow-hidden">
                <table className="min-w-full text-center bg-gray-200">
                  <thead className=" ">
                    <tr>
                      
                      
                      <th                    
                      ></th>
                      <th
                        scope="col"
                        className="text-sm font-medium text-gray-900 px-4 py-2"
                      >
                        
                      </th>
                      <th
                        scope="col"
                        className="text-sm font-medium text-gray-900 px-4 py-2"
                      >
                        Concepto
                      </th>
                      <th
                        scope="col"
                        className="text-sm font-medium text-gray-900 px-4 py-2"
                      >
                        Descripción Concepto
                      </th>
                      
                      
                    </tr>
                  </thead>
                 {
                    dataMotivo.map((item,index)=>(
                        <TablaCancelarSuministro key={index} item={item} passDataSeleccionarMotivo={passDataSeleccionarMotivo}/>
                    ))
                 }
                  
                </table>
              </div>
            </div>
          </div>
        </div>
          </div>
          <div className="flex flex-shrink-0 flex-wrap items-center justify-end p-2 border-t border-gray-200 rounded-b-md">
            <button
              type="button"
              onClick={handleCancelarClick}
              className="inline-block px-4 py-1.5 bg-purple-600 text-white font-medium text-xs leading-tight uppercase rounded shadow-md hover:bg-purple-700 hover:shadow-lg focus:bg-purple-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-purple-800 active:shadow-lg transition duration-150 ease-in-out"
              data-bs-dismiss="modal"
            >
              No
            </button>
            <button
              type="button"
              onClick={handleOnclickCancelarDespacho}
              className="inline-block px-4 py-1.5 bg-blue-600 text-white font-medium text-xs leading-tight uppercase rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out ml-1"
            >
              Si
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ModalCancelarSuministro